import React from "react";
import { Lock } from "lucide-react";
import mastercardMark from "../../../assets/svg/billing/Mastercard.svg";
import razorpayMark from "../../../assets/svg/billing/Razorpay.svg";
import rupayMark from "../../../assets/svg/billing/RuPay.svg";
import upiMark from "../../../assets/svg/billing/UPI.svg";
import visaMark from "../../../assets/svg/billing/Visa.svg";

/**
 * What can be paid with, and who is taking the money, under the summary.
 *
 * The networks' own marks, as supplied — trademarked artwork that had to come
 * from the design team rather than be approximated here. Each is drawn at the
 * size its file is authored at, which is what keeps four logos of four
 * different proportions reading as one row: they were scaled to sit together
 * before they arrived, and re-fitting them to a common height here would undo
 * that (a Mastercard is nearly square, a RuPay is four times as wide).
 *
 * The line beneath names the gateway, which is a thing the buyer is entitled
 * to know before pressing Pay: it is who the card details will actually go to.
 */
const METHODS = [
  { name: "UPI", src: upiMark, width: 33, height: 10 },
  { name: "RuPay", src: rupayMark, width: 43, height: 12 },
  { name: "Visa", src: visaMark, width: 29, height: 10 },
  { name: "Mastercard", src: mastercardMark, width: 18, height: 12 },
];

const PaymentMethods: React.FC = () => (
  <div className="flex flex-col items-center gap-3">
    <ul className="flex flex-wrap items-center justify-center gap-4">
      {METHODS.map((method) => (
        <li key={method.name} className="flex items-center">
          {/* Named rather than left decorative: which cards are taken is part
              of the offer, and someone who cannot see the marks is deciding
              the same thing by them. */}
          <img
            src={method.src}
            alt={method.name}
            width={method.width}
            height={method.height}
          />
        </li>
      ))}
    </ul>

    <p className="flex items-center gap-1.5 text-[12px] 3xl:text-[13px] text-ink-subtle">
      <Lock aria-hidden="true" className="h-3.5 w-3.5 flex-shrink-0" />
      Powered by
      {/* The mark carries the name, so the alt text is the word the sentence
          would otherwise have had — it has to read as one line either way. */}
      <img src={razorpayMark} alt="Razorpay" width={65} height={14} />
      subscriptions
    </p>
  </div>
);

export default PaymentMethods;
